import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Label from './Label';
import Judges from './Judges';
import Total from './Total';
import Tricks from './Tricks';
import Needs from './Needs';
import oget from 'oget';

export default
class LeaderboardCellJudgeScores extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        athlete: PropTypes.object.isRequired,
        colors: PropTypes.object.isRequired,
        scoreStyle: PropTypes.object.isRequired,
        roundConfig: PropTypes.object.isRequired
    }

    render() {
        const {
            t,
            athlete,
            colors,
            scoreStyle,
            roundConfig
        } = this.props;

        const label = oget(
            athlete,
            'details.Runs.judgesLabel',
            []
        );

        const runs = oget(
            athlete,
            'details.Runs',
            {}
        );

        const tricks = oget(
            athlete,
            'details.Tricks',
            {}
        );

        const needs = oget(
            athlete,
            'details.Needs.values[0]'
        );

        const { showTotal, showNeeds } = roundConfig;

        return (
            <div className="cell cell-scores">
                {showTotal && <Label hide={true}>
                    Total
                </Label>}

                {showTotal && <Total
                    athlete={athlete}
                    colors={colors.scores}
                    scoreStyle={scoreStyle}
                />}

                {showNeeds &&
                    <Label hide={true}>
                        Needs
                    </Label>
                }

                {showNeeds &&
                    <Needs
                        t={t}
                        hide={true}
                        athlete={athlete}
                        colors={colors.scores}
                        scoreStyle={scoreStyle}
                    >
                        {needs}
                    </Needs>
                }

                <Label className="judges">
                    {label}
                </Label>

                <Judges
                    athlete={athlete}
                    runs={runs}
                    colors={colors.scores}
                    scoreStyle={scoreStyle}
                    roundConfig={roundConfig}
                />

                <Label hide={true}>
                    {tricks.label}
                </Label>

                <Tricks
                    athlete={athlete}
                    colors={colors.scores}
                    values={tricks.values}
                    roundConfig={roundConfig}
                    scoreStyle={scoreStyle}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableLeaderboard/scored/scores/CellJudgeScores.js